import React, { useEffect, useRef, useState } from "react";
// Chakra imports
import {
  Flex,
  Grid,
  Table,
  Tbody,
  Icon,
  Text,
  Th,
  Thead,
  Tr,
  Box,
  Select,
  FormLabel,
  Input,
  Badge,
  Button,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  useDisclosure,
} from "@chakra-ui/react";

// Custom components
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";

// Table Components
import TablesTableRow from "components/Tables/TablesTableRow";

// Data
import { tablesTableData } from "variables/general";
import { PagingControls } from "components/ui/pagination";
import GradientBorder from "components/GradientBorder/GradientBorder";
import CustomDateInput from "components/CustomField/CustomDateInput";
import ChakraStyledSelect from "components/CustomField/ChakraStyledSelect";
import useApiReq from "variables/apireq";
import { FiCode, FiEdit } from "react-icons/fi";
import { IoCodeSharp } from "react-icons/io5";
import { Loader } from "components/Loader/loader";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom";
import { useLoader } from "components/Loader/loader";
import { AiFillCloseCircle } from "react-icons/ai";
import { FaCheckCircle } from "react-icons/fa";
import { motion } from "framer-motion";
import { BsFillEyeFill } from "react-icons/bs";
import SubmissionModal from "components/Modal/SubmissionModal";

// Icons

function List() {
  const titleColor = "white";
  const [currentPage, setCurrentPage] = useState(1);
  const [itemcount, setItemCount] = useState(10);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(itemcount);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const { setIsLoading, isLoading } = useLoader();
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [isOpen, setOpen] = useState(false);
  const [modalIndex, setmodalIndex] = useState(null);
  const [group, setGroup] = useState(null);
  const [show, setShow] = useState(false);
  const chnageshow = () => {
    setShow(!show);
  };
  const history = useHistory();
  const toast = useToast({ position: "top" });
  const ChnageOpen = (index = null) => {
    setmodalIndex(index);
    setOpen(!isOpen);
  };
  const [isMobalOpen, setIsMobalOpen] = useState(false);
  const [modaldata, setModalData] = useState("");

  const [rejectReason, setRejectReason] = useState("");

  const [isRejectDialogOpen, setIsRejectDialogOpen] = useState(false);
  const cancelRef = useRef();
  const campaignUuid = useRef(null);
  const publishedImages = useRef(null);
  const publishedLink = useRef(null);
  const [pendingRejectUuid, setPendingRejectUuid] = useState(null);

  const [isUnderReview, setIsUnderReview] = useState(true);

  const { isOpen: isSubmissionModalOpen, onOpen, onClose } = useDisclosure();

  // check if the user is publisher or advertiser from local storage
  const isPublisher = localStorage.getItem("group") === "Publisher";
  const isAdvertiser = localStorage.getItem("group") === "Advertiser";
  const isMarketing = localStorage.getItem("group") === "Marketing";
  const isEditor = localStorage.getItem("group") === "Editor";
  const isNewsroom = localStorage.getItem("group") === "Newsroom";

  const handleCampaignnApprove = async (uuid) => {
    setIsLoading(true);
    try {
      const res = await useApiReq({
        method: "POST",
        url: `campaign/approve/`,
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data: {
          uuid: uuid,
          approved: "Approved",
        },
      });
      if (res.error) {
        setError(res.error || res.message);
      } else {
        toast({
          title: "Success",
          description: "Campaign Approved Successfully",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCampaignnReject = async (uuid, reason) => {
    setIsLoading(true);
    try {
      const res = await useApiReq({
        method: "POST",
        url: `campaign/approve/`,
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data: {
          uuid: uuid,
          approved: "Rejected",
          reject_reason: reason,
        },
      });
      if (res.error) {
        setError(res.error || res.message);
      } else {
        toast({
          title: "Success",
          description: "Campaign Rejected Successfully",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  console.log("modaldata", modaldata);

  // useEffect(() => {
  //   if (
  //     (modaldata?.approved &&
  //       modaldata?.approved?.toLowerCase() === "under review") ||
  //     (modaldata?.approved_marketing &&
  //       modaldata?.approved_marketing?.toLowerCase() === "under review") ||
  //     (modaldata?.approved_editor &&
  //       modaldata?.approved_editor?.toLowerCase() === "under review")
  //   ) {
  //     setIsUnderReview(true);
  //   } else {
  //     setIsUnderReview(false);
  //   }
  // }, [modaldata]);

  useEffect(() => {
    const approvedValue = modaldata?.approved?.toLowerCase();
    const marketingValue = modaldata?.approved_marketing?.toLowerCase();
    const editorValue = modaldata?.approved_editor?.toLowerCase();

    const underReview =
      (isPublisher && approvedValue === "under review") ||
      (isMarketing && marketingValue === "under review") ||
      (isEditor && editorValue === "under review");

    setIsUnderReview(underReview);
  }, [modaldata, isPublisher, isMarketing, isEditor]);

  const setModalOpen = () => {
    if (isMobalOpen) {
      setModalData("");
      setRejectReason("");
      setShow(false);
    }
    setIsMobalOpen(!isMobalOpen);
  };

  const ChnageOpen2 = (index = null) => {
    setmodalIndex(index);
    setOpen(!isOpen);
  };

  const fetchGroup = async () => {
    try {
      const res = await useApiReq({
        method: "GET",
        url: "group/",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (res.error) {
        setError(res.error || res.message);
      } else {
        setGroup(res.response.reverse());
      }
    } catch (err) {
      setError(err);
    }
  };

  useEffect(() => {
    if (error) {
      toast({
        title: "Error",
        description: error,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  }, [error]);

  const fetchCampaigns = async (data) => {
    setIsLoading(true);
    try {
      const res = await useApiReq({
        method: "POST",
        url: "campaign/",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data: data,
      });
      if (res.error) {
        setError(res.error?.message || res.error);
      } else {
        setData(res.response.reverse());
        if (group === null) {
          await fetchGroup();
        }
      }
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const text = (child) => {
    return (
      <Text fontSize="sm" color="#fff" fontWeight="normal">
        {child}
      </Text>
    );
  };

  const badge = (child) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Badge
          borderRadius="10px"
          px="2"
          colorScheme={
            child === "Approved"
              ? "green"
              : child === "Rejected"
              ? "red"
              : "yellow"
          }
          color="white"
          variant="solid"
          h={{ base: "20px", md: "30px" }}
          fontSize={{ base: "sm", md: "md" }}
          textAlign="center"
          py={{ base: "4px", md: "4px" }}
        >
          {child}
        </Badge>
      </div>
    );
  };

  const btn = (text, onclick, disabled = false) => {
    return (
      <Button
        p="2px 10px"
        bg="brand.20"
        borderRadius="4px"
        variant="no-hover"
        onClick={onclick}
        textColor={"gray.400"}
        _hover={{ bg: "#0099a2", color: "#fff", textColor: "#fff" }}
        disabled={disabled}
        cursor="pointer"
      >
        <Text fontSize="sm" fontWeight="bold">
          {text}
        </Text>
      </Button>
    );
  };

  const icon = ({ child, color }) => {
    return <Icon as={child} color={color} size={45} />;
  };

  const edit = (uuid) => {
    return (
      <Button
        p="0px"
        bg="transparent"
        textColor={"gray.400"}
        _hover={{
          color: "#ffffff",
          textColor: "#ffffff",
        }}
        _active="none"
        onClick={() =>
          history.push(
            `/${localStorage
              .getItem("group")
              .toLowerCase()}/pr/update/?uuid=${uuid}`
          )
        }
      >
        <Icon as={FiEdit} cursor="pointer" />
      </Button>
    );
  };
  const tag = (index, disabled) => {
    return (
      <Button
        p="0px"
        bg="transparent"
        textColor={"gray.400"}
        _hover={{
          color: "#ffffff",
          textColor: "#ffffff",
        }}
        _active="none"
        onClick={() => ChnageOpen(index)}
        disabled={disabled}
      >
        <Icon as={IoCodeSharp} cursor={disabled ? "not-allowed" : "pointer"} />
      </Button>
    );
  };

  const report = (uuid, disabled) => {
    return (
      <Button
        p="2px 10px"
        bg="brand.20"
        borderRadius="4px"
        variant={"no-hover"}
        textColor={"gray.400"}
        _hover={{ bg: "#0099a2", color: "#ffffff", textColor: "#ffffff" }}
        cursor={"pointer"}
        disabled={disabled}
        onClick={() =>
          history.push(
            `/${localStorage
              .getItem("group")
              .toLowerCase()}/pr/report/?uuid=${uuid}`
          )
        }
      >
        <Text
          fontSize="sm"
          fontWeight="bold"
          cursor={disabled ? "not-allowed" : "pointer"}
        >
          Report
        </Text>
      </Button>
    );
  };

  const getOptimalData = (row, index) => {
    const data = {};
    data["Date"] = text(new Date(row.created_at).toLocaleDateString());
    data["Campaign Name"] = text(row.name);
    data["Review"] = btn("Review", () => {
      const temp = {
        "Campaign Name": row.name,
        "Brand Name": row.brand_name,
        "Advertiser Name": row.package.advertiser_name,
        "Campaign Type": row.type,
        Objective: row.objective,
        Banner: JSON.parse(row.banner),
        Content: row.content,
        Gender: row.gender,
        "Age Groups": row.age_groups,
        "Location List": row.location_list,
        "Interests List": row.targeting_list,
        "Additional Info": row.additional_info,
      };
      setModalOpen();

      setModalData({
        ...temp,
        uuid: row.uuid,
        approved: row.approved,
        approved_marketing: row.approved_marketing,
        approved_editor: row.approved_editor,
        approved_newsroom: row.approved_newsroom,
      });
    });
    data["Tag"] = tag(index, row.type !== "Online&Analytic");
    // data["Analytics"] = icon(
    //   !row.package.analytics
    //     ? { child: AiFillCloseCircle, color: "red.400" }
    //     : { child: FaCheckCircle, color: "green.400" }
    // );
    // data["Facebook"] = icon(
    //   !row.package.facebook
    //     ? { child: AiFillCloseCircle, color: "red.400" }
    //     : { child: FaCheckCircle, color: "green.400" }
    // );

    data["PR Type"] = text(row.type);

    data["Status"] = badge(row.approved);

    data["Edit"] = edit(row.uuid);

    data["Report"] =
      row.type === "Online&Analytic"
        ? report(row.uuid || "", row.approved !== "Approved")
        : btn("Submission", () => {
            onOpen();
            campaignUuid.current = row.uuid;
            publishedImages.current = row.published_images;
            publishedLink.current = row.published_link;
          });

    return data;
  };

  const handleContentClick = (value) => {
    const mimeMatch = value.match(/^data:(.*?);base64,/);
    if (!mimeMatch) return;

    const mimeType = mimeMatch[1];

    // Expanded MIME to extension mapping
    const mimeToExt = {
      "application/pdf": "pdf",
      "application/msword": "doc",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        "docx",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        "xlsx",
      "text/plain": "txt",
      "application/vnd.ms-excel": "xls",
      "application/vnd.ms-powerpoint": "ppt",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        "pptx",
    };

    const fileExt = mimeToExt[mimeType] || "file"; // default fallback
    const base64Data = value.split(",")[1];

    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length)
      .fill()
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], {
      type: mimeType,
    });
    const fileURL = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = fileURL;
    a.download = `content.${fileExt}`;
    a.click();
  };

  const getHeaders = () => {
    return [
      "Date",
      "Campaign Name",
      "Review",
      "Tag",
      "PR Type",
      "Status",
      "Edit",
      "Action",
    ];
  };

  useEffect(() => {
    fetchCampaigns({});
  }, []);

  useEffect(() => {
    if (startDate && endDate && group) {
      const data = {
        start_date: startDate.toLocaleDateString(),
        end_date: endDate.toLocaleDateString(),
        group: group.uuid,
      };

      fetchCampaigns(data);
    } else if (startDate && endDate) {
      const data = {
        start_date: startDate.toLocaleDateString(),
        end_date: endDate.toLocaleDateString(),
      };

      fetchCampaigns(data);
    }
  }, [startDate, endDate, group]);

  useEffect(() => {
    setStart((currentPage - 1) * itemcount);
    setEnd(currentPage * itemcount);
  }, [currentPage, itemcount]);
  if (isLoading) {
    return <div></div>;
  }
  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      {/* Authors Table */}
      <Card overflowX={{ sm: "scroll", xl: "hidden" }} pb="0px">
        <CardHeader p="6px 0px 22px 0px">
          <Box w="100%">
            <Text fontSize="lg" color="#fff" fontWeight="bold">
              PR History
            </Text>
            <Grid
              templateColumns={{
                sm: "1fr",
                md: "1fr 1fr",
                lg: "1fr 1fr 1fr ",
              }}
              gap={6}
              minW={{ sm: "100%", md: "100%" }}
              w="100%"
              mt="24px"
            >
              <Flex direction="column" w={{ base: "100%", lg: "100%" }}>
                <FormLabel
                  color={titleColor}
                  ms="4px"
                  fontSize="sm"
                  fontWeight="normal"
                >
                  Start Date
                </FormLabel>
                <GradientBorder
                  mb="24px"
                  h="50px"
                  w={{ base: "100%", lg: "100%" }}
                  borderRadius="20px"
                >
                  <CustomDateInput
                    selectedDate={startDate}
                    setSelectedDate={setStartDate}
                  />
                </GradientBorder>
              </Flex>
              <Flex direction="column" w={{ base: "100%", lg: "100%" }}>
                <FormLabel
                  color={titleColor}
                  ms="4px"
                  fontSize="sm"
                  fontWeight="normal"
                >
                  End Date
                </FormLabel>
                <GradientBorder
                  mb="24px"
                  h="50px"
                  w={{ base: "100%", lg: "100%" }}
                  borderRadius="20px"
                >
                  <CustomDateInput
                    selectedDate={endDate}
                    setSelectedDate={setEndDate}
                  />
                </GradientBorder>
              </Flex>
              <Flex direction="column" w={{ base: "100%", lg: "100%" }}>
                <FormLabel
                  color={titleColor}
                  ms="4px"
                  fontSize="sm"
                  fontWeight="normal"
                >
                  Campaign Group
                </FormLabel>
                <GradientBorder
                  mb="24px"
                  h="50px"
                  w={{ base: "100%", lg: "100%" }}
                  borderRadius="20px"
                >
                  <ChakraStyledSelect placeholder="Select Group" />
                </GradientBorder>
              </Flex>
              {/* <Flex direction='column' w={{ base: "100%", lg: "100%" }}>
                <FormLabel
                  color={titleColor}
                  ms='4px'
                  fontSize='sm'
                  fontWeight='normal'
                >
                  Status
                </FormLabel>
                <GradientBorder
                  mb='24px'
                  h='50px'
                  w={{ base: "100%", lg: "100%" }}
                  borderRadius='20px'
                >
                  <Select
                    color={titleColor}
                    bg={{
                      base: "rgb(19,21,54)",
                    }}
                    border='transparent'
                    borderRadius='20px'
                    fontSize='sm'
                    size='lg'
                    w={{ base: "100%", lg: "100%" }}
                    maxW='100%'
                    h='46px'
                    type='text'
                    placeholder='Select Status'
                    name='status'
                    sx={{
                      option: {
                        backgroundColor: "rgb(19,21,54)",
                        color: "white",
                      },
                    }}
                  >
                    <option value='Approved'>Approved</option>
                    <option value='under_review'>Under Review</option>
                    <option value='Delivered'>Delivered</option>
                  </Select>
                </GradientBorder>
              </Flex> */}
            </Grid>
          </Box>
        </CardHeader>
        <CardBody>
          <Table
            variant="simple"
            color="#fff"
            minH={{ base: "100px", lg: "100px" }}
          >
            <Thead>
              <Tr my=".8rem" ps="0px" color="gray.400">
                {getHeaders().map((header) => {
                  return (
                    <Th
                      ps="0px"
                      color="gray.400"
                      fontFamily='"Oxygen",serif'
                      borderBottomColor="#56577A"
                      textAlign="center"
                    >
                      {header}
                    </Th>
                  );
                })}
              </Tr>
            </Thead>
            <Tbody>
              {data?.length === 0 && (
                <Tr>
                  <Th colSpan="7" textAlign="center">
                    <Text fontSize="sm" color="gray.400" fontWeight="normal">
                      No data available
                    </Text>
                  </Th>
                </Tr>
              )}
              {data?.slice(start, end).map((row, index, arr) => {
                return (
                  <TablesTableRow
                    data={getOptimalData(row, index)}
                    lastItem={index === arr?.length - 1}
                    setOpen={ChnageOpen}
                    isOpen={isOpen}
                    openIndex={modalIndex}
                    currentIndex={index}
                  />
                );
              })}
              <Modal isOpen={isMobalOpen} onClose={setModalOpen} size="3xl">
                <ModalOverlay />
                <ModalContent
                  p="20px"
                  bg={{
                    base: "rgb(19,21,56)",
                  }}
                >
                  <ModalHeader>
                    <Text fontSize="lg" color="#fff" fontWeight="bold">
                      {" Campaign Details"}
                    </Text>
                  </ModalHeader>
                  <ModalCloseButton color="#fff" />
                  <ModalBody>
                    {/* Form */}
                    <GradientBorder
                      p="2px"
                      w="100%"
                      me={{
                        base: "none",
                        lg: "30px",
                        xl: "none",
                      }}
                    >
                      <Flex
                        background="transparent"
                        color="#fff"
                        borderRadius="30px"
                        direction="column"
                        p="24px"
                        minW={{
                          base: "unset",
                          md: "430px",
                          xl: "450px",
                        }}
                        w="100%"
                        mx={{ base: "0px" }}
                        bg={{
                          base: "rgb(19,21,56)",
                        }}
                      >
                        {Object.entries(modaldata).map(([key, value]) => {
                          const isArray = Array.isArray(value);
                          const isBoolean = typeof value === "boolean";
                          const isBannerArray = key.toLowerCase() === "banner";

                          if (key === "uuid") return null; // Skip uuid field
                          if (key === "approved") return null; // Skip approved field
                          if (key === "approved_marketing") return null; // Skip approved_marketing field
                          if (key === "approved_editor") return null; // Skip approved_editor field
                          if (key === "approved_newsroom") return null; // Skip approved_newsroom field

                          const isContentFile =
                            key.toLowerCase() === "content" &&
                            typeof value === "string";

                          return (
                            <Grid
                              templateColumns="1fr 1.5fr"
                              gap={6}
                              w="full"
                              mt="24px"
                              key={key}
                            >
                              <Text fontWeight="500" fontSize="16px">
                                {key
                                  .replace(/_/g, " ")
                                  .replace(/\b\w/g, (c) => c.toUpperCase())}
                              </Text>

                              <Box>
                                {/* Show all banner images */}
                                {isBannerArray ? (
                                  <Flex gap={4} wrap="wrap">
                                    {value.map((imgSrc, idx) => {
                                      return (
                                        <motion.div
                                          key={idx}
                                          whileHover={{ scale: 1.05 }}
                                          whileTap={{ scale: 0.95 }}
                                        >
                                          <img
                                            src={imgSrc}
                                            alt={`Banner ${idx + 1}`}
                                            style={{
                                              width: "100px",
                                              height: "100px",
                                              borderRadius: "10px",
                                              marginBottom: "10px",
                                            }}
                                          />
                                        </motion.div>
                                      );
                                    })}
                                  </Flex>
                                ) : isContentFile ? (
                                  // Show content file with filename and download icon
                                  <Flex align="center" gap={2}>
                                    <Text
                                      onClick={() => handleContentClick(value)}
                                      fontSize="16px"
                                      fontWeight="500"
                                      style={{ cursor: "pointer" }}
                                    >
                                      View File
                                    </Text>
                                    <BsFillEyeFill
                                      onClick={() => handleContentClick(value)}
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "20px",
                                      }}
                                    />
                                  </Flex>
                                ) : (
                                  <Text
                                    fontSize="16px"
                                    fontWeight="500"
                                    display="flex"
                                    flexWrap="wrap"
                                  >
                                    {isArray
                                      ? value
                                          .slice(0, show ? value.length : 3)
                                          .join(", ")
                                      : isBoolean
                                      ? value
                                        ? "Yes"
                                        : "No"
                                      : value}
                                    {/* "+ more" toggle for long arrays */}
                                    {isArray && value.length > 3 && !show && (
                                      <Button
                                        p="0px"
                                        ml={2}
                                        fontSize={"sm"}
                                        size="sm"
                                        variant="ghost"
                                        bg={"#3991725D"}
                                        _hover={{
                                          bg: "#39917298",
                                          color: "#fff",
                                        }}
                                        onClick={chnageshow}
                                      >
                                        + {value.length - 3}
                                      </Button>
                                    )}
                                  </Text>
                                )}
                              </Box>
                            </Grid>
                          );
                        })}
                      </Flex>
                    </GradientBorder>
                  </ModalBody>
                  <ModalFooter>
                    <Flex justify="flex-end" align="center" gap={4} w="100%">
                      {(isPublisher || isMarketing || isEditor) && (
                        <>
                          <Button
                            colorScheme="blue"
                            onClick={() => {
                              handleCampaignnApprove(modaldata?.uuid);
                              setModalOpen();
                            }}
                            disabled={!isUnderReview}
                          >
                            Approved
                          </Button>
                          <Button
                            colorScheme="red"
                            onClick={() => {
                              setPendingRejectUuid(modaldata?.uuid);
                              setIsRejectDialogOpen(true);
                            }}
                            disabled={!isUnderReview}
                          >
                            Reject
                          </Button>
                        </>
                      )}

                      <Button
                        variant="outline"
                        colorScheme="blue"
                        mr={3}
                        onClick={setModalOpen}
                      >
                        Close
                      </Button>
                    </Flex>
                  </ModalFooter>
                </ModalContent>
              </Modal>

              <AlertDialog
                isOpen={isRejectDialogOpen}
                leastDestructiveRef={cancelRef}
                onClose={() => setIsRejectDialogOpen(false)}
              >
                <AlertDialogOverlay>
                  <AlertDialogContent bg="rgb(19,21,56)" color="#fff">
                    <AlertDialogHeader fontSize="lg" fontWeight="bold">
                      Reject Campaign
                    </AlertDialogHeader>

                    <AlertDialogBody>
                      <Text mb={2}>Please provide a reason for rejection:</Text>
                      <Input
                        placeholder="Enter rejection reason"
                        value={rejectReason}
                        onChange={(e) => setRejectReason(e.target.value)}
                        bg="#fff"
                        color="#000"
                      />
                    </AlertDialogBody>

                    <AlertDialogFooter>
                      <Button
                        colorScheme="blue"
                        ref={cancelRef}
                        onClick={() => setIsRejectDialogOpen(false)}
                      >
                        Cancel
                      </Button>
                      <Button
                        colorScheme="red"
                        onClick={() => {
                          handleCampaignnReject(
                            pendingRejectUuid,
                            rejectReason
                          );
                          setIsRejectDialogOpen(false);
                          setModalOpen();
                        }}
                        ml={3}
                      >
                        Submit
                      </Button>
                    </AlertDialogFooter>
                  </AlertDialogContent>
                </AlertDialogOverlay>
              </AlertDialog>
            </Tbody>
          </Table>
        </CardBody>
        {data
          .slice((currentPage - 1) * itemcount, currentPage * itemcount)
          .map((x) => (
            <Box bg={"transparent"} key={x.id}>
              {x.text}
            </Box>
          ))}

        <Flex justify="space-between" my=".5rem">
          <PagingControls
            currentPage={currentPage}
            onGoToPage={(newPageNumber) => setCurrentPage(newPageNumber)}
            pageSize={itemcount}
            totalCount={data?.length || 0}
            totalCountDescription={"campaigns"}
            showPageCount={true}
          />
          <Select
            w="80px"
            variant="outline"
            colorScheme="blackAlpha"
            bg="transparent"
            backgroundColor={"transparent"}
            backdropBlur={"10px"}
            textColor="white"
            borderColor="whiteAlpha.300"
            sx={{
              option: {
                backgroundColor: "rgb(19,21,54)",
                color: "white",
              },
            }}
            iconColor="white"
            onChange={(e) => {
              setItemCount(e.target.value);
            }}
            value={itemcount}
          >
            <option value="10" selected>
              10
            </option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </Select>
        </Flex>
      </Card>
      <SubmissionModal
        isOpen={isSubmissionModalOpen}
        onClose={onClose}
        uuid={campaignUuid.current}
        publishedImages={publishedImages.current}
        link={publishedLink.current}
      />
    </Flex>
  );
}

export default List;
